// extracted by mini-css-extract-plugin
module.exports = {"baseLayoutBody":"BaseLayout_baseLayoutBody__3u1_p"};